<template>
  <div>
    <Menu theme="dark" :open-names="['0','2','4']">
      <Submenu :name="ele.id" v-for="ele in menuData.filter(val=>val.ifShow)" :key="ele.id">
        <template slot="title">
          <Icon :type="ele.icon" />
          {{ele.text}}
        </template>
        <MenuItem :name="i.id" :to="{name:i.to}" v-for="i in ele.children.filter(val=>val.ifShow)" :key="i.id">{{i.text}}</MenuItem>
      </Submenu>
    </Menu>
  </div>
</template>

<script>
let authority = [];
let authData = JSON.parse(localStorage.getItem("authData"));
if (authData) {
  authority = authData.barRights;
}

export default {
  name: "menuBar",
  data() {
    return {
      defaultMenuData: [
        {
          id: "0",
          text: "产品流程",
          ifShow:true,
          icon: "ios-flask",
          children: [
            { text: "原材料", id: "0-1", to: "material",ifShow:true, },
            { text: "壳体", id: "0-2", to: "shell",ifShow:true, },
            { text: "蓄能器", id: "0-3", to: "accumulator",ifShow:true, },
            { text: "库存物品", id: "0-4", to: "goods",ifShow:true, },
            { text: "合同执行单", id: "0-5", to: "orderManage",ifShow:true, },
          ]
        },
        {
          id: "1",
          text: "文档报告",
          ifShow:true,
          icon: "ios-paper",
          children: [
            { text: "热处理报告", id: "1-1", to: "heatReport",ifShow:true, },
            { text: "硬度试验报告", id: "1-2", to: "hardReport",ifShow:true, },
            { text: "渗透检测报告", id: "1-3", to: "ptReport",ifShow:true, },
            { text: "水压试验报告", id: "1-4", to: "hydraulicReport",ifShow:true, },
            { text: "磁粉检测报告", id: "1-5", to: "mtReport",ifShow:true, },
            { text: "密封及动作性能试验报告", id: "1-6", to: "oilReport",ifShow:true, },
            { text: "自由出具", id: "1-7", to: "freeReport",ifShow:true, },
          ]
        },
        {
          id: "2",
          text: "数据统计",
          ifShow:true,
          icon: "ios-flask",
          children: [
            { text: "蓄能器", id: "2-1", to: "shell",ifShow:true, },
          ]
        },
        {
          id: "3",
          text: "其他",
          ifShow:true,
          icon: "ios-paper",
          children: [
            { text: "人员签名", id: "3-1", to: "signature",ifShow:true, },
            { text: "工序管理", id: "3-2", to: "processManage",ifShow:true, },
            { text: "流程管理", id: "3-3", to: "workflowManage",ifShow:true, },
            { text: "图纸管理", id: "3-4", to: "drawManage",ifShow:true, },
          ]
        },
      ]
    };
  },
  props: {},
  methods: {},
  computed:{
      menuData:function(){
          let newData = JSON.parse(JSON.stringify(this.defaultMenuData));
          if(authority.indexOf('super_all')!==-1){
              return newData;
          }else if(authority.length===0){
              return [];
          }else{
          for(let i=0;i<this.defaultMenuData.length;i++){
              for(let j=0;j<this.defaultMenuData[i].children.length;j++){
                  if(authority.indexOf(this.defaultMenuData[i].children[j].to)===-1){
                      newData[i].children[j].ifShow = false;
                  }else{
                    newData[i].children[j].ifShow = true;
                  }
              }
              if(newData[i].children.every(ele=>{return !ele.ifShow;})){
                  newData[i].ifShow = false;
              }else{
                newData[i].ifShow = true;
              }
          }
          return newData;
          }
      },
  }
};
</script>

<style scoped>
</style>